"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var THEME_MAP = {}; // 主题映射
/**
 * 获取对应的主题
 * @param type
 */
exports.getTheme = function (type) {
    return THEME_MAP[type.toLowerCase()];
};
/**
 * 注册主题
 * @param type
 * @param theme
 */
exports.registerTheme = function (type, theme) {
    if (exports.getTheme(type)) {
        throw new Error("Theme type '" + type + "' existed.");
    }
    THEME_MAP[type.toLowerCase()] = theme;
};
//# sourceMappingURL=factory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/theme/factory.js
// module id = 605
// module chunks = 37